import React, { ReactNode, useEffect, useRef } from "react";
import IconClose from "@/components/icons/IconClose";

export default function Modal({
  isOpen = false,
  onClose,
  children,
}: {
  isOpen?: boolean;
  onClose: () => void;
  children: ReactNode;
}): React.ReactElement {
  const ref: React.MutableRefObject<any> = useRef(null);

  // const handleClickOutside = (event: MouseEvent): void => {
  //   if (ref.current && !ref.current.contains(event.target)) {
  //     onClose();
  //   }
  // };

  useEffect(() => {
    if (isOpen) {
      document.body.classList.toggle("overflow-hidden", true);
    } else {
      document.body.classList.toggle("overflow-hidden", false);
    }

    return () => {
      document.body.classList.toggle("overflow-hidden", false);
    };
  }, [isOpen]);

  // useEffect(() => {
  //   document.addEventListener("click", handleClickOutside, true);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside, true);
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleKeyUp = (event: KeyboardEvent) => {
  //     if (event.key === "Escape") {
  //       onClose();
  //     }
  //   };
  //
  //   document.addEventListener("keyup", handleKeyUp);
  //
  //   return () => {
  //     document.removeEventListener("keyup", handleKeyUp);
  //   };
  // }, []);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-[600] flex flex-col overflow-auto bg-black/40">
          <div className={"min-h-10 flex-1"}></div>
          <div
            className="relative mx-auto w-full max-w-3xl rounded-t-lg bg-white lg:rounded-lg"
            ref={ref}
          >
            <button
              type={"button"}
              aria-label={"Zamknij okno"}
              className="absolute right-4 top-4 flex h-14 w-14 cursor-pointer items-center justify-center lg:right-7 lg:top-7"
              onClick={() => onClose()}
            >
              <IconClose className={"w-8"} />
            </button>
            <div className={"px-10 py-14 lg:px-28 lg:py-20"}>{children}</div>
          </div>
          <div className={"hidden min-h-10 flex-1 lg:block"}></div>
        </div>
      )}
    </>
  );
}
